import app from '@/main';

export default {
  logIn(state, payload) {
    state.accessToken = payload.accessToken;
    state.refreshToken = payload.refreshToken;
    state.userSeqId = payload.userSeqId;
    state.userName = payload.userName;
    state.userEmail = payload.userEmail;
    state.profileImage = payload.profileImage;

    // 토큰을 로컬 스토리지에 저장
    localStorage.accessToken = payload.accessToken;
    localStorage.refreshToken = payload.refreshToken;
    localStorage.userSeqId = payload.userSeqId;
    localStorage.userName = payload.userName;
    localStorage.userEmail = payload.userEmail;
    localStorage.profileImage = payload.profileImage;
  },

  logOut(state) {
    Object.keys(state).forEach((key) => {
      if (Array.isArray(state[key])) {
        state[key] = [];
      } else if (key !== 'language') {
        state[key] = null;
      }
    });
    localStorage.clear();
  },

  addTag(state, tag) {
    state.tagList.push(tag);
  },

  delTag(state, idx) {
    state.tagList.splice(idx, 1);
  },

  copyTagList(state) {
    state.tmpTagList = state.tagList.slice();
  },

  clearTagList(state) {
    state.tagList = [];
  },

  toggleMenu(state, isShow) {
    state.showMenu = isShow;
  },

  setI18n(state, payload) {
    app.$i18n.locale = payload;
    localStorage.language = payload;
    state.language = payload;
  },

  setJobs(state, payload) {
    state.jobs = payload;
    localStorage.setItem('jobs', JSON.stringify(payload));
  },

  setUserName(state, payload) {
    localStorage.userName = payload;
    state.userName = payload;
  },

  setUserEmail(state, payload) {
    state.userEmail = payload;
  },

  setLoginType(state, payload) {
    localStorage.setItem('loginType', payload);
    state.loginType = payload;
  },

  setLastSelectedMatchTab(state, payload) {
    localStorage.setItem('lastSelectedMatchTab', payload);
    state.lastSelectedMatchTab = payload;
  },

  setTmpURL(state, payload) {
    localStorage.setItem('tmpURL', payload);
    state.tmpURL = payload;
  },

  // 회원가입 시, 사용하는 임시 데이터.
  setTmpUserEmail(state, payload) {
    state.tmpUserEmail = payload;
  },
  setTmpUserPassword(state, payload) {
    state.tmpUserPassword = payload;
  },
  setTmpUserNickname(state, payload) {
    state.tmpUserNickname = payload;
  },
  setTmpUserName(state, payload) {
    state.tmpUserName = payload;
  },
  setTmpUserBirth(state, payload) {
    state.tmpUserBirth = payload;
  },
  setTmpUserSex(state, payload) {
    state.tmpUserSex = payload;
  },
  setTmpUserEducation(state, payload) {
    state.tmpUserEducation = payload;
  },
  setTmpValidEmailFlag(state, payload) {
    state.tmpValidEmailFlag = payload;
  },
  setTmpValidPasswordFlag(state, payload) {
    state.tmpValidPasswordFlag = payload;
  },
  setTmpValidNicknameFlag(state, payload) {
    state.tmpValidNicknameFlag = payload;
  },
  setTmpValidNameFlag(state, payload) {
    state.tmpValidNameFlag = payload;
  },
  clearTmpUserEmail(state) {
    state.tmpUserEmail = null;
  },
  clearTmpUserPassword(state) {
    state.tmpUserPassword = null;
  },
  clearTmpUserNickname(state) {
    state.tmpUserNickname = null;
  },
  clearTmpUserName(state) {
    state.tmpUserName = null;
  },
  clearTmpUserBirth(state) {
    state.tmpUserBirth = null;
  },
  clearTmpUserSex(state) {
    state.tmpUserSex = null;
  },
  clearTmpUserEducation(state) {
    state.tmpUserEducation = null;
  },
  clearTmpValidEmailFlag(state) {
    state.tmpValidEmailFlag = null;
  },
  clearTmpValidPasswordFlag(state) {
    state.tmpValidPasswordFlag = null;
  },
  clearTmpValidNicknameFlag(state) {
    state.tmpValidNicknameFlag = null;
  },
  clearTmpValidNameFlag(state) {
    state.tmpValidNameFlag = null;
  },
  addTmpTag(state, tag) {
    state.tmpTagList.push(tag);
  },
  delTmpTag(state, idx) {
    state.tmpTagList.splice(idx, 1);
  },
  clearTmpTagList(state) {
    state.tmpTagList = [];
  },
  copyTmpTagList(state) {
    state.tagList = state.tmpTagList.slice();
  },
  setQCnt(state, qCnt) {
    state.qCnt = qCnt;
  },
  setTmpProfileImage(state, url) {
    state.tmpProfileImage = url;
  },
  setProfileImage(state, url) {
    state.profileImage = url;
  },
  setTmpClientId(state, clientId) {
    state.tmpClientId = clientId;
  },
  clearTmpClientId(state) {
    state.tmpClientId = null;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js